const moment = require("moment");

exports.specialty = () => {
    return [
        { value: "", text: "선택" },
        { value: "피부과", text: "피부과" },
        { value: "성형외과", text: "성형외과" },
        { value: "가정의학과", text: "가정의학과" },
        { value: "산부인과", text: "산부인과" },
        { value: "정형외과", text: "정형외과" },
        { value: "내과", text: "내과" },
        { value: "이비인후과", text: "이비인후과" },
        { value: "비뇨기과", text: "비뇨기과" },
        { value: "기타", text: "기타" },
    ];
};


exports.domain = () => {
    return [
        { value: "", text: "직접입력" },
        { value: "naver.com", text: "naver.com" },
        { value: "hanmail.net", text: "hanmail.net" },
        { value: "nate.com", text: "nate.com" },
        { value: "gmail.com", text: "gmail.com" },
    ];
};

exports.age = () => {
    return [
        { value: "", text: "연령대 선택" },
        { value: "20", text: "20대" },
        { value: "30", text: "30대" },
        { value: "40", text: "40대" },
        { value: "50", text: "50대" },
        { value: "60", text: "60대" },
        { value: "70", text: "70대" },
        { value: "80", text: "80대" },
        { value: "90", text: "90대" },
    ];
};

exports.crop = () => {
    return [
        { value: "가지", text: "가지" },
        { value: "감귤", text: "감귤" },
        { value: "감자", text: "감자" },
        { value: "고추", text: "고추" },
        { value: "곡류", text: "곡류" },
        { value: "단감", text: "단감" },
        { value: "담배", text: "담배" },
        { value: "당근", text: "당근" },
        { value: "대추", text: "대추" },
        { value: "대파", text: "대파" },
        { value: "딸기", text: "딸기" },
        { value: "마늘", text: "마늘" },
        { value: "매실", text: "매실" },
        { value: "멜론", text: "멜론" },
        { value: "무", text: "무" },
        { value: "배", text: "배" },
        { value: "벼", text: "벼" },
        { value: "복숭아", text: "복숭아" },
        { value: "사과", text: "사과" },
        { value: "상추", text: "상추" },
        { value: "생강", text: "생강" },
        { value: "수박", text: "수박" },
        { value: "시금치", text: "시금치" },
        { value: "양배추", text: "양배추" },
        { value: "양파", text: "양파" },
        { value: "오이", text: "오이" },
        { value: "옥수수", text: "옥수수" },
        { value: "유자", text: "유자" },
        { value: "인삼", text: "인삼" },
        { value: "자두", text: "자두" },
        { value: "참깨", text: "참깨" },
        { value: "참외", text: "참외" },
        { value: "콩", text: "콩" },
        { value: "키위", text: "키위" },
        { value: "토마토", text: "토마토" },
        { value: "파프리카", text: "파프리카" },
        { value: "포도", text: "포도" },
        { value: "호박", text: "호박" },
        { value: "기타작물", text: "기타 작물" },
        { value: "기타채소", text: "기타 채소" },
        { value: "기타", text: "기타" },
    ];
};

exports.crop25 = () => {
    return [
        { value: "감귤", text: "감귤" },
        { value: "감자", text: "감자" },
        { value: "고구마", text: "고구마" },
        { value: "고추", text: "고추" },
        { value: "단감", text: "단감" },
        { value: "당근", text: "당근" },
        { value: "대추", text: "대추" },
        { value: "대파", text: "대파" },
        { value: "딸기", text: "딸기" },
        { value: "마늘", text: "마늘" },
        { value: "무", text: "무" },
        { value: "배", text: "배" },
        { value: "배추", text: "배추" },
        { value: "복숭아", text: "복숭아" },
        { value: "사과", text: "사과" },
        { value: "상추", text: "상추" },
        { value: "수박", text: "수박" },
        { value: "양파", text: "양파" },
        { value: "오이", text: "오이" },
        { value: "인삼", text: "인삼" },
        { value: "자두", text: "자두" },
        { value: "참외", text: "참외" },
        { value: "콩", text: "콩" },
        { value: "토마토", text: "토마토" },
        { value: "포도", text: "포도" },
        { value: "기타", text: "기타" },
    ];
};

exports.productName = () => {
    return [
        { value: "나티보", text: "나티보" },
        { value: "데시스", text: "데시스" },
        { value: "라체스", text: "라체스" },
        { value: "루틴", text: "루틴" },
        { value: "머큐리듀오", text: "머큐리듀오" },
        { value: "머큐리슈퍼", text: "머큐리슈퍼" },
        { value: "모벤토", text: "모벤토" },
        { value: "미토스", text: "미토스" },
        { value: "밀베노크", text: "밀베노크" },
        { value: "바이고", text: "바이고" },
        { value: "벨룸 액상수화제", text: "벨룸 액상수화제" },
        { value: "벨룸 입제", text: "벨룸 입제" },
        { value: "세레나데아소", text: "세레나데아소" },
        { value: "스칼라", text: "스칼라" },
        { value: "시반토", text: "시반토" },
        { value: "신기록디", text: "신기록디" },
        { value: "실바코 수화제", text: "실바코 수화제" },
        { value: "실바코플러스 액상수화제", text: "실바코플러스 액상수화제" },
        { value: "알리온", text: "알리온" },
        { value: "알리온플러스", text: "알리온플러스" },
        { value: "오베론스피드", text: "오베론스피드" },
        { value: "인피니트", text: "인피니트" },
        { value: "카운실 액상수화제", text: "카운실 액상수화제" },
        { value: "카운실 입제", text: "카운실 입제" },
        { value: "칼립소", text: "칼립소" },
        { value: "코니도 액상수화제", text: "코니도 액상수화제" },
        { value: "코니도 입제", text: "코니도 입제" },
        { value: "타스타", text: "타스타" },
        { value: "텔도", text: "텔도" },
        { value: "티비앙", text: "티비앙" },
        { value: "프린트", text: "프린트" },

    ];
};

exports.whereToBuy = () => {
    return [
        { value: "시판", text: "시판" },
        { value: "농협", text: "농협" },
        { value: "기타", text: "기타" },
    ];
};


// exports.region1 = () => {
//     return [
//         { value: "전국", text: "전국" },
//         { value: "서울특별시", text: "서울특별시" },
//         { value: "부산광역시", text: "부산광역시" },
//         { value: "대구광역시", text: "대구광역시" },
//         { value: "인천광역시", text: "인천광역시" },
//         { value: "광주광역시", text: "광주광역시" },
//         { value: "대전광역시", text: "대전광역시" },
//         { value: "울산광역시", text: "울산광역시" },
//         { value: "세종특별자치시", text: "세종특별자치시" },
//         { value: "경기도", text: "경기도" },
//         { value: "강원도", text: "강원도" },
//         { value: "충청북도", text: "충청북도" },
//         { value: "충청남도", text: "충청남도" },
//         { value: "전라북도", text: "전라북도" },
//         { value: "전라남도", text: "전라남도" },
//         { value: "경상북도", text: "경상북도" },
//         { value: "경상남도", text: "경상남도" },
//         { value: "제주특별자치도", text: "제주특별자치도" },
//     ];
// };

// exports.region1 = () => {
//     return [
//         { value: "전국", text: "전국" },
//         { value: "전국", text: "전국" },
//         { value: "중부", text: "중부" },
//         { value: "충청", text: "충청" },
//         { value: "호남", text: "호남" },
//         { value: "안동", text: "안동" },
//         { value: "대구", text: "대구" },
//         { value: "기타", text: "기타" },
//     ];
// };

// exports.region2 = () => {
//     return [
//         { value: "전체", text: "전체" },
//         { value: "가평군", text: "가평군" },
//         { value: "고양시", text: "고양시" },
//         { value: "과천시", text: "과천시" },
//         { value: "광명시", text: "광명시" },
//     ];
// };

exports.segment = () => {
    return [
        { value: "", text: "선택" },
        { value: "segment1", text: "세그먼트1" },
        { value: "segment2", text: "세그먼트2" },
        { value: "segment3", text: "세그먼트3" },
        { value: "segment4", text: "세그먼트4" },
    ];
};

exports.sample_isProvision = () => {
    return [
        { value: "", text: "지급여부" },
        { value: "Y", text: "지급" },
        { value: "N", text: "미지급" },
    ];
};

exports.sample_productName = () => {
    return [
        { value: "", text: "제품명" },
        { value: "제품명2", text: "제품명2" },
        { value: "제품명3", text: "제품명3" },
        { value: "제품명4", text: "제품명4" },
        { value: "제품명5", text: "제품명5" },
    ];
};

exports.personInCharge = () => {
    return [
        { value: "", text: "담당자명" },
        { value: "담당자명1", text: "담당자명1" },
        { value: "담당자명2", text: "담당자명2" },
        { value: "담당자명3", text: "담당자명3" },
        { value: "담당자명4", text: "담당자명4" },
    ];
};

exports.staffTableHeader = () => {
    return [
        { text: "이름", value: "name", sortable: false, width: 120 },
        { text: "담당지역", value: "area", sortable: false, },
    ];
};